// @flow

import * as React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { withProps, getContext } from './index'
import formValidateRules from './formValidateRules'
import { getFormValues, setFormValues } from '../../redux/basic'

export default function (WrappedComponent: React.ComponentType<*>) {
  return compose(
    getContext({ formId: PropTypes.string }),
    formValidateRules,
    // $FlowFixMe
    connect(
      function (state, props: *) {
        return {
          formValues: getFormValues(props.formId)
        }
      },
      function (dispatch, props: *) {
        return {
          setFormValues (values: {}) {
            setFormValues(props.formId, values)
          }
        }
      },
      null,
      { withRef: true }
    ),
    withProps(props => {
      let formValues = props.formValues
      return { formValues: formValues ? formValues.toJS() : {} }
    })
  )(WrappedComponent)
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/formValues.js